import React from 'react';

import { ScanSquare } from '@ui-library/icons';

import styles from './Label.module.scss';

interface LabelProps {
  htmlFor?: string;
  label: string;
  required?: boolean;
  autofilled?: boolean;
}

const Label = ({ htmlFor, label, required, autofilled }: LabelProps) => (
  <div className={styles.Label}>
    <label htmlFor={htmlFor}>{label}</label>
    {required && <span className={styles.Required}>*</span>}
    {autofilled && <ScanSquare size={14} className={styles.Autofilled} />}
  </div>
);

export default Label;
